import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

declare var google: any;

@Directive({
  selector: '[appGooglePlacesAutocomplete]',
  standalone: false,
  exportAs: 'ngx-places'
})
export class GooglePlacesAutocompleteDirective implements OnInit, OnDestroy {
  @Output() onAddressChange: EventEmitter<any> = new EventEmitter();
  @Input() options: any = {};

  private autocomplete: any;
  private eventListener: any;

  constructor(
    private el: ElementRef,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  ngOnInit() {
    this.initializeAutocomplete();
  }

  ngOnDestroy() {
    if (this.eventListener) {
      google.maps.event.removeListener(this.eventListener);
    }
  }

  private initializeAutocomplete() {
    // Wait for Google Maps API to be loaded
    if (typeof google !== 'undefined' && google.maps && google.maps.places) {
      this.createAutocomplete();
    } else {
      // Retry after a short delay if Google Maps isn't loaded yet
      setTimeout(() => this.initializeAutocomplete(), 100);
    }
  }

  private createAutocomplete() {
    const defaultOptions = {
      componentRestrictions: { country: ['us', 'ca'] },
      // Restrict returned Place fields to avoid deprecated utc_offset in Places payloads.
      fields: [
        'formatted_address',
        'address_components',
        'geometry',
        'place_id',
        'name',
        'utc_offset_minutes'
      ]
    };

    const options = { ...defaultOptions, ...this.options };

    this.autocomplete = new google.maps.places.Autocomplete(
      this.el.nativeElement,
      options
    );

    this.eventListener = this.autocomplete.addListener('place_changed', () => {
      this.handlePlaceSelect();
    });
  }

  private handlePlaceSelect() {
    try {
      const place = this.autocomplete.getPlace();

      if (!place || !place.geometry) {
        console.warn('Google Places: No place geometry found');
        return;
      }

    // Format the address data to match the expected format from ngx-google-places-autocomplete
    const addressData = {
      formatted_address: place.formatted_address,
      address_components: place.address_components,
      geometry: place.geometry,
      place_id: place.place_id,
      name: place.name,
      utc_offset_minutes: place.utc_offset_minutes,
      // Preserve reference without property expansion to avoid touching deprecated getters.
      raw_place: place
    };

    // Update the form control value if NgControl is available
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(place.formatted_address);
    } else {
      // Fallback: set the input value directly
      this.el.nativeElement.value = place.formatted_address;
    }

      // Emit the address change event
      this.onAddressChange.emit(addressData);
    } catch (error) {
      console.error('Error handling place selection:', error);
    }
  }
}

